import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}
export const XIcon: FC<IconProps> = ({ className, size }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 24 24'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={
          'M16.9687 4.20001H19.5937L13.8187 10.8375L20.6437 19.8H15.3187L11.1187 14.3625L6.3562 19.8H3.6937L9.8812 12.75L3.3562 4.20001H8.8312L12.5812 9.18751L16.9687 4.20001ZM16.0312 18.225H17.4937L8.0437 5.70001H6.4687L16.0312 18.225Z'
        }
        fill={'#262626'}
      />
    </svg>
  )
}
